import { useRef, useState, useEffect } from "react";

export default function AudioPlayer({ src }) {
  const audioRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const audio = audioRef.current;

    const loaded = () => setDuration(audio.duration);
    const update = () => setCurrentTime(audio.currentTime);

    audio.addEventListener("loadedmetadata", loaded);
    audio.addEventListener("timeupdate", update);

    return () => {
      audio.removeEventListener("loadedmetadata", loaded);
      audio.removeEventListener("timeupdate", update);
    };
  }, []);

  const togglePlay = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      audioRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleSeek = (e) => {
    const value = e.target.value;
    audioRef.current.currentTime = value;
    setCurrentTime(value);
  };

  const formatTime = (time) => {
    if (!time) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  const progress = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div style={styles.wrapper}>
      <div style={styles.player}>
        {/* 🔘 кнопка + текст */}
        <div style={styles.top}>
          <button onClick={togglePlay} style={styles.button}>
            <span style={styles.icon}>
              {isPlaying ? "⏸" : "▶"}
            </span>
          </button>

          <span style={styles.text} onClick={togglePlay}>
            {isPlaying
              ? "Відтворюється..."
              : "Прослухати життєпис"}
          </span>
        </div>

        {/* ⏱ таймінг */}
        <div style={styles.time}>
          <span>{formatTime(currentTime)}</span>
          <span>{formatTime(duration)}</span>
        </div>

        {/* 📊 прогрес бар */}
        <input
          type="range"
          min="0"
          max={duration}
          value={currentTime}
          onChange={handleSeek}
          style={{
            ...styles.range,
            background: `linear-gradient(to right, #1DB954 ${progress}%, #555 ${progress}%)`,
          }}
        />

        <audio
          ref={audioRef}
          src={src}
          onEnded={() => setIsPlaying(false)}
        />
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "center",
    margin: "30px 0",
  },

  player: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    background: "#121212",
    padding: "16px",
    borderRadius: "14px",
    width: "100%",
    maxWidth: "500px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
    transition: "transform 0.2s ease",
  },

  top: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },

  button: {
    background: "#1DB954",
    border: "none",
    borderRadius: "50%",
    width: "42px",
    height: "42px",
    color: "white",
    cursor: "pointer",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  icon: {
    fontSize: "18px",
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  text: {
    color: "white",
    fontSize: "15px",
    cursor: "pointer",
  },

  time: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "12px",
    color: "#aaa",
  },

  range: {
    width: "100%",
    height: "4px",
    appearance: "none",
    borderRadius: "2px",
    cursor: "pointer",
  },
};